import React, { useState, useRef, useEffect } from "react";
import "./58MM/print.css";
import pdf from "../../assets/images/pdf.webp";
import { useLocation } from "react-router-dom";
import { ToWords } from "to-words";
import close from "../../assets/images/close-button.png";
import prnt from "../../assets/images/print.png";
import whtaapp from "../../assets/images/whatsapp.webp";

import ReactToPrint from "react-to-print";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { useDbContext } from "../../context/DbContext";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { selectGeneralSettings } from "../../app/settingsSlice";
function Print({ printData, onClose, totalwt }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { schemeRecInfoData, tableData, index } = printData || {};
  
  const { dbCode } = useDbContext();
  const [companyName, setCompanyName] = useState("");
  const [oldBalance, setOldBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const GeneralSettings = useSelector(selectGeneralSettings);
  const obSetting = GeneralSettings.find(
    (item) => item.Name === "ENABLE OB IN SCHEME RECEIPT PRINT"
  );
  const showOB = obSetting && obSetting.ss_status === 1;

  useEffect(() => {
    fetchcompanydetails();
  }, []);

  const [accumulatedWeightVal, setAccumulatedWeightVal] = useState(totalwt || 0);

  useEffect(() => {
    if (totalwt) {
      setAccumulatedWeightVal(totalwt);
    }
  }, [totalwt]);

  useEffect(() => {
    if (tableData && index) {
      const ledcode = tableData[index - 1 || 0]?.name?.[0] || tableData[index - 1 || 0]?.name;
      if (ledcode) {
        fetchOldBalance(ledcode);
      }
    }
  }, [tableData, index]);

  const fetchOldBalance = async (ledcode) => {
    try {
      const entryNo = schemeRecInfoData?.EntryNo || "";
      const currentFrmId = schemeRecInfoData?.frmID || "";
      const cleanLed = Array.isArray(ledcode) ? ledcode[0] : (ledcode?.value ?? ledcode);
      const response = await axios.get(
        `${apiBaseUrl}/main/recbalances/${cleanLed}/${dbCode}?entryNo=${entryNo}&frmId=${currentFrmId}`
      );
      if (response.data && response.data[0]) {
        const b = response.data[0];
        const isSaved = b.isSaved === 1 || b.isSaved === true;
        const currentWt = parseFloat(tableData[index - 1 || 0]?.totalGm || tableData[index - 1 || 0]?.gm || 0);
        setOldBalance(parseFloat(b.oldBalance || 0));
        if (isSaved) {
          setAccumulatedWeightVal(parseFloat(b.totalWeight || 0));
        } else {
          setAccumulatedWeightVal(parseFloat(b.oldWeight || 0) + currentWt);
        }
      } else {
        const fallbackRes = await axios.get(
          `${apiBaseUrl}/main/recprintob/${cleanLed}/${dbCode}`
        );
        setOldBalance(parseFloat(fallbackRes.data[0]?.oldBalance || 0));
      }
    } catch (error) {
      console.error("Error fetching old balance:", error);
    }
  };

  const fetchcompanydetails = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/findCompanyDetails/${dbCode}`
      );
      const foundData = response.data[0];
      setCompanyName(foundData.name || "SherGold ERP");
    } catch (error) {
      console.error("Error fetching company datas:", error.message);
    }
  };

  const printRef = useRef();
  const location = useLocation();

  const toWords = new ToWords();

  const downloadPDF = () => {
    const printRoot = document.querySelector(".printRoot");
    const pdfButton = document.querySelector(".RecpdfDownloadButton");
    const closeButton = document.querySelector(".RecCloseButton");
    const pntButton = document.querySelector(".RecPrintButton");
    const whtbutton = document.querySelector(".whtbutton");

    const originalBorder = printRoot.style.border;
    pdfButton.style.visibility = "hidden";
    closeButton.style.visibility = "hidden";
    pntButton.style.visibility = "hidden";
    whtbutton.style.visibility = "hidden";

    printRoot.style.border = "none";

    html2canvas(printRoot, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("receipt.pdf");

      pdfButton.style.visibility = "visible";
      closeButton.style.visibility = "visible";
      pntButton.style.visibility = "visible";
      whtbutton.style.visibility = "visible";

      printRoot.style.border = originalBorder;
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    const [day, month, year] = formattedDate.split(" ");
    return `${day}/${month}/${year}`;
  };

  const generatePDF = async (canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a5");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    return pdf.output("blob");
  };

  const uploadPDF = async (pdfBlob) => {
    const formData = new FormData();
    const newFileName = `receipt_${Date.now()}.pdf`;
    formData.append("id", "shergoldErp");
    formData.append("file", pdfBlob, newFileName);
    
    try {
      const uploadResponse = await axios.post(
        "https://imageupload.shersoft.tech/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (uploadResponse.status === 200) {
        return `https://imageupload.shersoft.tech/image/shergoldErp/${newFileName}`;
      } else {
        throw new Error("File upload failed");
      }
    } catch (error) {
      console.error("Error during file upload:", error);
      throw new Error("Failed to upload PDF");
    }
  };

  const [WhatsAppsettingsData, setWhatsAppsettingsData] = useState({
    EntryName: "SCHEME RECEIPT",
    Message: "",
    appkey: "",
    authkey: "",
    phoneNumber: "",
    Media: null,
  });

  const fetchAccNmData = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/findbyaccnametable/${tableData[index - 1 || 0].name
        }/${dbCode}`
      );
      return response.data[0].mobileNo;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      throw new Error("Failed to fetch account data");
    }
  };

  const fetchwhatsappsettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/${eName}`
      );

      const whtsappData = response.data[0];
      return whtsappData;
    } catch (error) {
      console.error("Error fetching whtsappData Values:", error.message);
    }
  };

  const fetchWhatsAppsettings = async () => {
    try {
      const phNo = await fetchAccNmData();
      
      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/SCHEME RECEIPT`
      );
      const whtAppstngsData = response.data[0];
      
      const apiData = await fetchwhatsappsettings("SCHEME RECEIPT");
      
      const message = apiData.MessageBody.replace("${accountNo}", tableData[index - 1 || 0].accountNumber[1])
        .replace("${customerName}", tableData[index - 1 || 0].name[1])
        .replace("${total}", tableData[index - 1 || 0].total || tableData[index - 1 || 0].amount)
        .replace("Total:${grandTotal}", "")
        .replace("${netwt}", totalwt || 0)
        .replace("${gm}", tableData[index - 1 || 0].totalGm || tableData[index - 1 || 0].gm);

      return {
        phoneNumber: phNo,
        appkey: whtAppstngsData.appKey,
        authkey: whtAppstngsData.Authkey,
        message: message,
        EntryName: whtAppstngsData.Voucher,
      };
    } catch (error) {
      console.error("Error in fetchWhatsAppsettings:", error);
      throw new Error("Failed to fetch WhatsApp settings");
    }
  };

  // Helper function to send message via Rapiwha API
  const sendRapiwhaMessage = async (phoneNumber, appkey, text, mediaUrl = null) => {
    try {
      let apiUrl = `https://panel.rapiwha.com/send_message.php?apikey=${appkey}&number=91${phoneNumber}`;
      
      if (mediaUrl) {
        // For media, use text parameter to send the URL
        apiUrl += `&text=${encodeURIComponent(mediaUrl)}`;
      } else {
        // For regular message
        apiUrl += `&text=${encodeURIComponent(text)}`;
      }
      
      //////console.log("Sending request to:", apiUrl);
      
      const response = await axios.get(apiUrl);
      
      if (response.data && response.data.result_code === 0) {
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data?.description || 'Failed to send message');
      }
    } catch (error) {
      console.error("Error sending Rapiwha message:", error);
      throw error;
    }
  };

  const sendToWhatsApp = async () => {
    try {
      setLoading(true);
      
      const whatsAppData = await fetchWhatsAppsettings();
      
      setWhatsAppsettingsData((prev) => ({
        ...prev,
        phoneNumber: whatsAppData.phoneNumber,
        appkey: whatsAppData.appkey,
        Message: whatsAppData.message,
        EntryName: whatsAppData.EntryName,
      }));

      // Generate PDF
      const fileUrl = await generateAndUploadPDF();
      
      // Send messages
      if (fileUrl && whatsAppData.message) {
        // Send media first, then message
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          fileUrl
        );
        
        // Send text message
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          whatsAppData.message
        );
        
        alert("Message and PDF sent successfully!");
      } else if (fileUrl) {
        // Send only media
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          fileUrl
        );
        alert("PDF sent successfully!");
      } else if (whatsAppData.message) {
        // Send only message
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          whatsAppData.message
        );
        alert("Message sent successfully!");
      } else {
        alert("Nothing to send - both message and PDF are empty");
      }
      
    } catch (error) {
      console.error("Error in sendToWhatsApp:", error);
      alert(error.message || "Failed to send message");
    } finally {
      restoreButtonVisibility();
      setLoading(false);
    }
  };

  // Helper function to generate and upload PDF
  const generateAndUploadPDF = async () => {
    const printRoot = document.querySelector(".printRoot");
    hideButtons();
    const originalBorder = printRoot.style.border;
    printRoot.style.border = "none";
    try {
      const canvas = await html2canvas(printRoot, { scale: 1.5 });
      const pdf = await generatePDF(canvas);
      return await uploadPDF(pdf);
    } finally {
      restoreButtonVisibility();
      printRoot.style.border = originalBorder;
    }
  };

  // Helper functions for button visibility
  const hideButtons = () => {
    const buttons = [
      ".RecpdfDownloadButton",
      ".RecCloseButton",
      ".RecPrintButton",
      ".whtbutton",
    ].forEach((selector) => {
      const button = document.querySelector(selector);
      if (button) button.style.visibility = "hidden";
    });
  };

  const restoreButtonVisibility = () => {
    const buttons = [
      ".RecpdfDownloadButton",
      ".RecCloseButton",
      ".RecPrintButton",
      ".whtbutton",
    ].forEach((selector) => {
      const button = document.querySelector(selector);
      if (button) button.style.visibility = "visible";
    });
  };
  
  const spinnerProps = {
    color: "#026CC3",
    height: 12,
    width: 5,
    radius: 1,
    margin: 3,
    size: 30,
    speedMultiplier: 0.8,
    css: {
      opacity: "0.8",
    },
  };
  
  return (
    <div className="printRoot">
      <div className="printBody" ref={printRef}>
        <div className="absolute w-[98%] pl-[1%] pr-[1%] h-auto flex justify-end gap-3 mt-2">
          <button
            className="RecCloseButton  "
            style={{ padding: "0", backgroundColor: "red", border: "none" }}
            onClick={onClose}
          >
            <img src={close} alt="X" style={{ width: "75%", height: "75%" }} />
          </button>
          <div className="RecpdfDownloadButton " onClick={downloadPDF}>
            <img
              src={pdf}
              alt="PDF"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <ReactToPrint
            trigger={() => (
              <button
                className="RecPrintButton flex justify-center "
              >
                <img src={prnt} alt="PNT" className="h-full " />
              </button>
            )}
            content={() => printRef.current}
          />
          <div
            className="RecpdfDownloadButton whtbutton"
            onClick={sendToWhatsApp}
          >
            <img
              src={whtaapp}
              alt="WhtApp"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>

        <div className="printHead">
          <label htmlFor="" className="receiptHead">
            RECEIPT
          </label>
          <label htmlFor="" className="receiptCompanyName">
            {companyName}
          </label>
        </div>
        <div id="printContent" className="printContent">
          <div className="printContentBody">
            <div className="printContentBodyRow1">
              <div className="printContentBodyRow1sec1">
                <span className="RecPrintfontsize">No.</span>
                <span className="RecPrintfontsize printmobentryno">
                  {schemeRecInfoData.EntryNo} -
                  {tableData[index - 1 || 0].agent[1].substring(0, 3)}
                </span>
              </div>
              <div className="printContentBodyRow1sec2">
                <span className="RecPrintfontsize">Date:</span>
                <span className="recMobdateSpan RecPrintfontsize">
                  {formatDate(schemeRecInfoData.date)}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2">
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize">Account Number</span>
              </div>
              <div className="printContentBodyRow2sec">
                <span
                  style={{ fontWeight: "600" }}
                  className="recMargin Recboldfontsize"
                >
                  {tableData[index - 1 || 0].accountNumber[1]}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2">
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize">Received From</span>
              </div>
              <div className="printContentBodyRow2sec">
                <span
                  style={{ fontWeight: "600" }}
                  className="recMargin Recboldfontsize"
                >
                  {tableData[index - 1 || 0].name[1]}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2">
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize sofrup">
                  The sum of rupees
                </span>
              </div>
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize recMargin wordssize">
                  {toWords.convert(tableData[index - 1 || 0].total || tableData[index - 1 || 0].amount, {
                    currency: false,
                  })}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2">
              <div className="printContentBodyRow2sec">
                <span
                  style={{ fontStyle: "italic" }}
                  className="bycashspan RecPrintfontsize"
                >
                  By Cash / cheque/DD No
                </span>
              </div>
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize recMargin">CASH</span>
              </div>
            </div>
            <div className="printContentBodyRow2">
              <div className="printContentBodyRow2sec amntdiv">
                <div className="printContentBodyRow2secAmnt">
                  <div className="printContentBodyRow2secAmntsec1">
                    <span className="rupeeSign" style={{ color: "white" }}>
                      ₹
                    </span>
                  </div>
                  <div className="printContentBodyRow2secAmntsec2">
                    {tableData[index - 1 || 0].total || tableData[index - 1 || 0].amount}
                  </div>
                </div>
              </div>
              <div className="printContentBodyRow2sec"></div>
            </div>
            <div className="printContentBodyRow2">
              <span className="pritnFooterData RecPrintfontsize">
                * All Cheque / DD are subject to realization
              </span>
            </div>
            <div className="printContentBodyRow2">
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize">Rate/Gm</span>
              </div>
              <div className="printContentBodyRow2sec">
                <span
                  className="rupeeSign recMargin"
                  style={{ marginRight: "4px", marginLeft: 0 }}
                >
                  ₹
                </span>
                <span className="RecPrintfontsize " style={{ marginLeft: "0" }}>
                  {schemeRecInfoData.rate}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2 recWght">
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize">Weight</span>
              </div>
              <div className="printContentBodyRow2sec">
                <span className="RecPrintfontsize recMargin">
                  {tableData[index - 1 || 0].totalGm || tableData[index - 1 || 0].gm}
                  &nbsp;gm
                </span>
              </div>
            </div>
          </div>

          <div className="printContentBodyfooter">
            <div className="printContentBodyfootersec">
              <span className="RecPrintfontsize twt">Total Weight</span>
            </div>
            <div className="printContentBodyfootersec">
              <span className="RecPrintfontsize recMargin twt">
                {accumulatedWeightVal || totalwt || 0}
                &nbsp;gm
              </span>
            </div>
          </div>
          <div className="printContentBodyfooter">
            <div className="printContentBodyfootersec">
              <span className="RecPrintfontsize twt">Total Amount</span>
            </div>
            <div className="printContentBodyfootersec">
              <span className="RecPrintfontsize recMargin twt">
                ₹&nbsp;{(parseFloat(tableData[index - 1 || 0]?.total || tableData[index - 1 || 0]?.amount || 0) + parseFloat(oldBalance || 0)).toFixed(2)}
              </span>
            </div>
          </div>
          {showOB && (
            <div className="printContentBodyfooter">
              <div className="printContentBodyfootersec">
                <span className="RecPrintfontsize twt">Old Balance</span>
              </div>
              <div className="printContentBodyfootersec">
                <span className="RecPrintfontsize recMargin twt">
                  ₹&nbsp;{(oldBalance || 0).toFixed(2)}
                </span>
              </div>
            </div>
          )}
          
          <div
            className="printContentBodyfootersecsign "
            style={{ width: "100%", textAlign: "right", height: "10%" }}
          >
            <span
              className="RecPrintfontsize "
              style={{ marginRight: "10%", marginBottom: "2%" }}
            >
              Receiver Signature
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Print;